import React, { useEffect } from 'react';

import { useRouteToMyTeamLevels } from 'Deer/hooks/useRouteToL3';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { useDispatch } from 'react-redux';
import { setSelectedView } from 'reducers/viewsSlice';
import Header from 'screens/Team/Rabbit/Goals/Header';
import OKRInsights from 'screens/Team/Rabbit/Goals/Insights';

import { modifyString, StringModifier } from 'constants/copyHelpers';

import { PageTabbedNavigationV1 } from 'uiToolkitV1/PageTabbedNavigationV1';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cohort: any;
  headerLabel: string;
}

const DirectReportsGoalsInsights = ({ cohort, headerLabel }: Props) => {
  const dispatch = useDispatch();
  const { l3Options: tabs } = useRouteToMyTeamLevels();
  const { moduleName } = useOrganisationSettings();
  const modifiedHeaderLabel = `${headerLabel} ${modifyString(moduleName, StringModifier.PLURAL_SENTENCE_CASE)}`;

  useEffect(() => {
    dispatch(setSelectedView({ ...cohort }));
  }, [cohort]);

  // eslint-disable-next-line arrow-body-style
  useEffect(() => {
    return () => {
      dispatch(setSelectedView({}));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Header teamName={modifiedHeaderLabel} />

      <PageTabbedNavigationV1 tabs={tabs} />

      <OKRInsights />
    </>
  );
};

export default DirectReportsGoalsInsights;
